import styled from 'styled-components';
import { Row } from 'antd';
import * as AddressField from '../../components/AddressField/styles';
import * as LocationForm from '../../components/LocationForm/styles';
import * as Map from '../../components/Map/styles';

export const FooterRow = styled(Row)``;

export const Wrapper = styled.div`
  border-radius: 16px;
  padding: 20px 0 20px 0;
  overflow-y: auto;
  display: grid;
  grid-template-columns: 1fr 2fr;
  ${FooterRow} {
    display: none;
  }
  @media (max-width: 1024px) {
    padding-bottom: 35px;
  }
  @media only screen and (max-width: 980px) {
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 15px 0;
    ${FooterRow} {
      display: flex;
    }
    ${LocationForm.Button} {
      display: none;
    }
    ${LocationForm.Container} {
      width: 100%;
      * {
        font-size: 0.8rem;
      }
      ${LocationForm.SearchInnerWrapper} {
        height: auto;
        border-radius: 16px;
        border: 0.7px solid var(--border-color);
        padding: 0.8rem 1rem;
      }
      ${AddressField.Row} {
        margin-bottom: 0;
        padding-bottom: 10px;
      }
    }
    ${Map.Container} {
      flex: 1;
      > div {
        border-radius: 10px;
      }
    }
  }
  @media only screen and (min-width: 980px) and (max-height: 900px) {
    ${LocationForm.Container} {
      font-size: 0.7rem;
      ${LocationForm.SearchInnerWrapper} {
        padding: 0.7rem 2rem;
      }
      ${LocationForm.Button} {
        padding: 0 10px;
      }
    }
  }
`;

export const Button = styled.button`
  width: 100%;
  border: none;
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  &:hover {
    opacity: 0.7;
  }
  background: var(--button-color);
  border-radius: 5px;
  padding: 0.4rem 0;
  color: white;
  font-size: 1.3rem;
  cursor: pointer;
  > span {
    padding-left: 7px;
    font-size: 15px;
    vertical-align: middle;
  }
  @media (max-width: 768px) {
    width: 100%;
  }
`;
export const ErrorMessage = styled.p`
  text-align: center;
  border-radius: var(--border-radius);
  padding: 3px 5px;
  color: red;
  background: #ddd;
  position: absolute;
`;
